export const WEAPON = {
  id: 'uzi',
  label: 'U9-C',
  class: 'smg',
  caliber: '9x19',
  /** Gold-coin price in the armory; 0 = free starter/melee, never purchasable. */
  price: 650,
  rpm: 600,
  modes: ['auto', 'semi'],
  burstCount: 2,
  burstRpm: 700,
  burstDelay: 0.14,
  magSize: 32,
  reserve: 224,
  muzzleVelocity: 400,
  damage: 22,
  penetration: 0.4,
  dropoff: 0.5,
  maxRange: 200,
  dragK: 0.44,
  tracerEvery: 4,
  spreadHip: 2.8,
  spreadAds: 0.45,
  spreadPerShot: 0.3,
  spreadMax: 4.2,
  spreadDecay: 4.2,
  recoil: {
    pitch: 0.0068,
    yaw: 0.0035,
    kickBack: 0.014,
    kickUp: 0.006,
    roll: 0.03,
    punch: 0.28,
    freq: 11.5,
    damping: 0.38,
    patternLength: 32,
    patternSeed: 0x2b6e0c,
    climbShape: [1.4, 1.2, 1.05, 1.0],
    drift: 1.0,
  },
  adsTime: 0.2,
  adsFov: 0.8,
  viewFov: 0.9,
  reloadTac: 1.9,
  reloadEmpty: 2.6,
  inspectTime: 2.8,
  drawTime: 0.5,
  holsterTime: 0.32,
  /* Framing is functional but rougher than the other guns' — a compact
   * stamped-steel receiver with a vertical grip/magwell reads very
   * differently under the same relative camera offset than the tubular
   * AR-pattern guns do, and getting it as flattering as those would need
   * the same iterative, render-and-measure pass their hipPos/hipRot got. */
  hipPos: [0.105, -0.15, -0.29],
  hipRot: [-0.05, 0.072, -0.131],
  adsCant: [0, 0, 0.005],
  eyeRelief: 0.1,
  sprintPos: [0.086, -0.235, -0.25],
  sprintRot: [-0.38, 0.58, 0.19],
  lowReadyPos: [0.104, -0.248, -0.264],
  lowReadyRot: [-0.44, 0.125, -0.085],
  swayScale: 0.95,
  bobScale: 0.98,
  magLen: 0.2,
};

export const loadModel = () => import('../models/uzi.js').then((m) => m.buildUzi);
